function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import styled, { css } from 'styled-components';
var defaultSize = '24px';
var sizeCss = css(["", ""], function (_ref) {
  var size = _ref.size,
      theme = _ref.theme;
  return "\n    width: ".concat(theme.icon.size[size] || defaultSize, ";\n    height: ").concat(theme.icon.size[size] || defaultSize, ";\n  ");
});
var colorCss = css(["", " g,path{fill:currentColor;stroke:none;}*:not([stroke]){&[fill='none']{stroke-width:0;}}*[stroke*='#'],*[STROKE*='#']{stroke:inherit;fill:none;}*[fill-rule],*[FILL-RULE],*[fill*='#'],*[FILL*='#']{fill:currentColor;stroke:none;}"], function (_ref2) {
  var color = _ref2.color,
      theme = _ref2.theme;
  return "\n    fill: ".concat(theme.color[color], ";\n    color: ").concat(theme.color[color], ";\n\n    @media (forced-colors: active) and (prefers-color-scheme: light) {\n      && {\n        color: ").concat(theme.color.black, ";\n      }\n    }\n\n    @media (forced-colors: active) and (prefers-color-scheme: dark) {\n      && {\n        color: ").concat(theme.color.white, ";\n      }\n    }\n  ");
}); // eslint-disable-next-line react/prop-types

var Icon = function Icon(_ref3) {
  var color = _ref3.color,
      size = _ref3.size,
      theme = _ref3.theme,
      rest = _objectWithoutProperties(_ref3, ["color", "size", "theme"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    "aria-hidden": "true"
  }, rest));
};

export var StyledIcon = styled(Icon).withConfig({
  displayName: "Iconstyle__StyledIcon",
  componentId: "sc-82cwdi-0"
})(["display:inline-block;flex:0 0 auto;", " ", ""], function (_ref4) {
  var theme = _ref4.theme;
  return theme && theme.icon && sizeCss;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme && theme.color && colorCss;
});